import { render } from "./MyBenefit.vue?vue&type=template&id=53607aba&scoped=true"
import script from "./MyBenefit.vue?vue&type=script&lang=js"
export * from "./MyBenefit.vue?vue&type=script&lang=js"

import "./MyBenefit.vue?vue&type=style&index=0&id=53607aba&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53607aba"]])

export default __exports__